export default "__VITE_ASSET__CwoxRw$Z__"